import { render, staticRenderFns } from "./CardGrantingEffluentsChart.vue?vue&type=template&id=c5a8f45e&scoped=true"
import script from "./CardGrantingEffluentsChart.vue?vue&type=script&lang=js"
export * from "./CardGrantingEffluentsChart.vue?vue&type=script&lang=js"
import style0 from "./CardGrantingEffluentsChart.vue?vue&type=style&index=0&id=c5a8f45e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a8f45e",
  null
  
)

export default component.exports